import { Col, Row, Modal, message } from 'antd';
import React, { useState, useRef, useEffect, useContext, useMemo, useCallback, } from 'react'
import { PlusOutlined } from '@ant-design/icons';
import { Divider, Input, Select, Space, Button, Form } from 'antd';
import commonLib from '../../../control/commonLib';
import konsole from '../../../network/konsole';
import Services from '../../../network/Services';
import "./communicationmodal.css";
import { UserContext } from "../../../App.js";
import { ModalBody } from 'react-bootstrap';
import { isNullUndefine } from '../../../control/Constant.js';
import AtTheRateTextArea from '../AtTheRateTextArea.js';
import config from "../../../config.json"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


const initialContent = `
<table border='0' width='100%' cellspacing='0' cellpadding='0'> <tbody> <tr> <td style='padding: 10px 0 30px 0;'> 
<table style='border: 1px solid #cccccc; border-collapse: collapse;' border='0' width='600' cellspacing='0' cellpadding='0' align='center'> <tbody> <tr> <td style='border-bottom: 1px; border-bottom-style: solid; padding: 20px 0 30px 0; color: #153643; font-size: 28px; font-weight: bold; font-family: Arial, sans-serif;' align='center'>
<p style='font-size: 16px; font-weight: bold; font-family: sans-serif; text-decoration: none; line-height: 40px; width: 100%; display: inline-block; color: #871a27 !important;'>
AgingOptions<br/>@@SUBTENANTNAME</p>
</td></tr><tr> <td style='padding: 40px 30px 0px 30px;' bgcolor='#ffffff'> <table border='0' width='100%' cellspacing='0' cellpadding='0'> <tbody><tr>
 <td style='padding: 20px 0 30px 0; color: #153643; font-family: Arial, sans-serif; font-size: 16px; line-height: 20px'>

Please enter your email text here.

</td>
</tr><tr> <td style='padding: 30px 30px 30px 30px;' bgcolor='#6d6864'> <table border='0' width='100%' cellspacing='0' cellpadding='0'> <tbody> <tr> <td style='color: #ffffff; font-family: Arial, sans-serif; font-size: 14px;' width='50%'>AgingOptions<br/><span style='color: #ffffff;'>31919 6th Ave S, Suite A100</span><br/><span style='color: #ffffff;'>Federal Way, WA 98003.</span></td><td><span style='color: #ffffff;'>info@agingoptions.com</span><br/><span style='color: #ffffff;'>www.agingoptions.com</span><br/><span style='color: #ffffff;'> 1-877-76-AGING (24464) </span></td></tr></tbody> </table> </td></tr></tbody> </table> </td></tr></tbody></table>
`
export const AddcommunicationNewModal = (props) => {
    const [form] = Form.useForm();
    const { setLoader } = useContext(UserContext)
    const [lastdata, setlastdata] = useState(false)
    const [getChannelValue, setChannelValue] = useState()
    const [getOccurrenceSelectedValue, setOccurrenceSelectedValue] = useState()
    const [uploadPreTempDropDown, setuploadPreTempDropDown] = useState(false);
    const [getTextTemplateSelect, setTextTemplateSelect] = useState(false)
    const [getOccurrenceSelect, setOccurrenceSelect] = useState([]);
    const [GetCommMediumData, setCommMediumData] = useState([]);
    const [subtenantID, setSubtenantID] = useState()
    const [open, setOpen] = useState(false);
    const [textMessage, setTextMessage] = useState()
    const [showSerchTrue, setShowSerchTrue] = useState(true)
    const [firstselect1, setselect1] = useState(false)
    const [moduleData, setModuleData] = useState(false)
    const [screenId, setScreenId] = useState(0);
    let userId = commonLib.getObjFromStorage("stateObj").userId
    const [name, setName] = useState("");


    useEffect(() => {
        let subtenantID = commonLib.getSessionStoarge("subtenantId")
        setSubtenantID(subtenantID)
        getOccurrencefunction(subtenantID);
    }, [])

    useEffect(() => {




        form.setFieldsValue({
            "commChannel": getChannelValue?.value,
        })
    }, [GetCommMediumData[0]?.commChannelId, GetCommMediumData[0]?.commMediumRoles, GetCommMediumData[0]?.commMediumRoles[0]?.fromRoleId, GetCommMediumData[0]?.commMediumRoles[0]?.toRoleId])





    const handleClose = () => {

        form.resetFields();
        setChannelValue("")
        setName('');
        setCommMediumData(0)
        setuploadPreTempDropDown(false)
        props.setShowAddModal(false);
        getOccurrencefunction(subtenantID)
    }

    const handleTextUpdate = (e) => {
        form.setFieldsValue(
            {
                addTextOnly: e.target.value
            }
        )
    }


    const getOccurrenceSelectedValueFunction = async(value, key) => {

    //   getSelectedTextTemplateData
      const exestingResult =  await getPreTextTemplatesPathApiFunction()

      if(exestingResult !== 'err'){
          const filterReasult = exestingResult?.find((ele)=> ele?.screenId == value)
          setTextMessage(filterReasult?.displayContent)
          setScreenId(value)
                  form.setFieldsValue(
            {
                addTextOnly: filterReasult?.displayContent
            }
        )
        }
        setTextTemplateSelect(true)
        setuploadPreTempDropDown(true)
        setselect1(true)
        setOccurrenceSelectedValue(key)

        if (key?.key !== undefined) {
            setShowSerchTrue(false)
        }
        else {
        }
    }




    const newFunction = (getOccurrenceSelect, GetCommMediumData1) => {
        const disabledScreenIds = new Set(
            getOccurrenceSelect?.map(item => item.screenId)
        );
        const occuranceData2 = GetCommMediumData1?.map(item => ({
            ...item,
            disabled: disabledScreenIds.has(item.screenId)
        }));
        setScreenData(occuranceData2);
    };

    const createNewFunction = () => {
           postEmailTemplatesPathApi();
    }

    const getPreTextTemplatesPathApiFunction = () => {
        return new Promise((resolve, reject) => {
        const promises = Services.getTextTemplatesOnstantPathApi(config.SUBTENANT_ID)
            promises.then((response) => {
                 resolve(response?.data?.data)
            }).catch((error) => {
                resolve('err')
                })
                .finally(() => {
                    konsole.log("finish");
                });

        })
    };


    const getOccurrencefunction = (subtenantID) => {
        const promises = Services.getOccurrenceApi2()
        promises.then((response) => {
            setOccurrenceSelect(response.data.data)
            const resultModule = response?.data?.data?.length > 0 ? response.data.data.map(ele => ({id: ele?.moduleSectionId,label: ele?.moduleSectionName})) : [];
             const uniqueData = Array.from( new Map( resultModule.map(item => [item.id, item])).values());
            setModuleData(uniqueData)
            // newFunction(props?.GetCommMediumData, response.data.data)
        }).catch((error) => {
                konsole.log("error", error);
            })
            .finally(() => {
                konsole.log("finish");
            });
    }


    const postEmailTemplatesPathApi = () => {

        if(isNullUndefine(form.getFieldValue().addTextOnly)){
             message.error('Please enter your content')
             return
        }
        setLoader(true)
       const jsonObject = {
            "displayContentId": 0,
            "displayContent": form.getFieldValue().addTextOnly,
            "isActive": true,
            "upsertedBy": userId
        }
        const promises = Services.upsertDisplayContentPathApi(jsonObject)
        promises.then((response) => {
            const obj = {
                "subtenantId": subtenantID,
                "applicableConId": response?.data?.data?.[0]?.displayContentId,
                "screenId": screenId,
                "isActive": true,
                "upsertedBy": userId,
            }
            const promises = Services.postUpsertCommMediumApi(obj)
            promises.then((response) => {
              props?.GetCommMediumPathApiFuction(subtenantID)
                message.success('Content Created Successfully')
                handleClose()
                setLoader(false)

            }).catch((error) => {
            }).finally(() => {
            setLoader(false)


            });
        })
            .catch((error) => {
               setLoader(false)
            })
            .finally(() => {
            });

    }






    const onFinish = (e) => {
        createNewFunction()
    }



    const selectFuction = (visible) => {
        setOpen(visible)
        if (visible && getOccurrenceSelectedValue?.key != undefined) {
            setShowSerchTrue(true)
        }
    }



    let linkButton = document.getElementById("createLink");


        const modifyText = (command, defaultUi, value) => {
        document.execCommand(command, defaultUi, value)
        // setISUpdate(false)
    };




       const linkCreateButtonFunction = () => {
                   let userLink = prompt("Enter a URL");
                   if (!userLink) {
                    //    setISUpdate(false)
                       return;
                   }
                   if (/http/i?.test(userLink)) {
                       modifyText(linkButton?.id, false, userLink);
                    //    setISUpdate(false);
                       konsole.log("Link if")

                    }
                    else {
                        userLink = "" + userLink;
                        modifyText(linkButton?.id, false, userLink)
                    //    setISUpdate(false)
                   }


        }













    const [subModule,setSubModule] = useState()
    const [screenData,setScreenData] = useState()
    const moduleChange = (value, key) => {
        setSubModule()
        setScreenData()
        setTextMessage()
        form.resetFields(['addTextOnly', 'moduleSubSection', 'screenName']);
        const filtered = getOccurrenceSelect?.filter((ele) => ele?.moduleSectionId == key?.value)
        const uniqueData = Array.from(new Map(filtered.map(item => [item.moduleSubSectionId, item])).values());
        setSubModule(uniqueData)
    }

    const subModuleChange = (value, key) => {
        form.resetFields(['addTextOnly', 'screenName']);
        setScreenData()
        setTextMessage()
        const filtered = getOccurrenceSelect?.filter((ele) => ele?.moduleSubSectionId == key?.value)
        setScreenData(filtered)
        newFunction(props?.GetCommMediumData, filtered)
    }



      return (
        <div>
            <Modal
                centered={true}
                className="Modal-Main-Class"
                // title={<div className='d-flex justify-content-center'>Add Event Template</div>}
                visible={props?.showAddModal}
                footer={false}
                onCancel={handleClose}
                // closeIcon={<div className='text-light'> X</div>}
                maskClosable={false}
                closable={false}
                size="xl"
                width={1000}
                enforceFocus={false}
                bodyStyle={{ padding: '0px', borderRadius: '8px' }}>
                                 
     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 8px 12px 8px', borderBottom: '1px solid #bfbfbf' }}>
          <p style={{ fontSize: '16px', fontWeight: '700', color: '#333333', margin: 0 }}>
         Add Event Template
          </p>
          <span onClick={handleClose} style={{ cursor: 'pointer', fontSize: '25px', color: '#333333', lineHeight: 1, padding: '2px 6px' }}>×</span>
        </div>
                <Form form={form} name="useForm" onFinish={onFinish} onFinishFailed={(data) => konsole.log("errorin on Finsin", data)} 
                style={{padding:"16px"}} >
                    <Row>
                        <Col span={24}>

                            <Row className='d-flex justify-content-between'>

                                <Col span={11} xs={24} sm={24} md={11} lg={11}>
                                    <h6 style={{ marginLeft: "1px" }}>Module</h6>
                                    <Form.Item
                                        name="moduleSectionName"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select module"
                                            }
                                        ]}
                                        className="asignRoleTo-col m-0 pb-2"
                                    >
                                        <Select
                                            showSearch
                                            listHeight={100}
                                            className="commChannelSelect"
                                            // mode="multiple"
                                            maxTagCount="responsive"
                                            showArrow
                                            onChange={moduleChange}
                                            placeholder="Select a module"
                                            style={{ width: "100%" }}
                                        >

                                                  {
                                               !isNullUndefine(moduleData) && moduleData?.map((item) => (
                                                    <option value={item?.id} key={item?.id}
                                                    >{item?.label}</option>

                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                                 <Col span={11} xs={24} sm={24} md={11} lg={11}>
                                    <h6 style={{ marginLeft: "1px" }}>Sub Module</h6>

                                    <Form.Item
                                        name="moduleSubSection"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select Sub Module"
                                            }
                                        ]}
                                        className="asignRoleTo-col m-0 pb-2"
                                    >
                                        <Select
                                            showSearch
                                            listHeight={100}
                                            className="commChannelSelect"
                                            maxTagCount="responsive"
                                            showArrow
                                            placeholder="Select a Sub Module"
                                            style={{ width: "100%" }}
                                            disabled = {isNullUndefine(subModule)}
                                            onChange={subModuleChange}
                                        >

                                              {
                                               !isNullUndefine(subModule) && subModule?.map((item) => (
                                                    <option value={item?.moduleSubSectionId} key={item?.moduleSubSectionId}
                                                    >{item?.moduleSubSection}</option>

                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>


                            </Row>

                            <Row className='d-flex justify-content-between'>
                                  <Col span={11} xs={24} sm={24} md={11} lg={11} >
                                    <h6 style={{ marginLeft: "1px" }}>Screen Name</h6>
                                    <Form.Item
                                        name="screenName"

                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select Screen Name"
                                            }
                                        ]}>

                                        <Select
                                            className='SeminarRegistrationSelect Select-input'
                                            placeholder="Select a Screen Name"
                                            open={open}
                                            onChange={getOccurrenceSelectedValueFunction}
                                            onDropdownVisibleChange={(visible) => selectFuction(visible)

                                            }
                                            listHeight={90}
                                            defaultOpen={true}
                                            showSearch={showSerchTrue}
                                            disabled = {isNullUndefine(screenData)}


                                        >
                                            {
                                                screenData?.filter(data => data?.screenName?.toLowerCase().includes(name.toLowerCase())).map((item) => (
                                                    <option value={item?.screenId} key={item?.screenId} disabled={item.disabled} data={item}
                                                    >{item?.screenName}</option>

                                                ))
                                            }
                                        </Select>

                                    </Form.Item>

                                  </Col>
                            </Row>

                            <ModalBody className='Modal-Body-Add-Modal' style={{overflowY:"hidden"}}>
                                {uploadPreTempDropDown == true  &&

                                <>
                                    <div>

                                        <Row className='d-flex justify-content-between mb-1'>
                                        <Col span={24} md={24}>
                                                {
                                                    (uploadPreTempDropDown == true && getTextTemplateSelect == true)
                                                    &&
                                                    <div>
                                                        <Row >
                                                            <Col span={24}>
                                                                <Row className='d-flex justify-content-between'>

                                                                    <Col className='' span={24} xs={24} sm={24} md={24} lg={24}>
                                                                        <h6>Content</h6>

                                                                        <div className='mt-2 w-100'>

                                                                            <AtTheRateTextArea id="textAreaAt1" className="w-100" rows="4" handleTextUpdate={handleTextUpdate}  defaultText={textMessage} placeholder="" screenId={screenId} />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                }
                                        </Col>
                                        </Row>
                                    </div>
                                </>
                                }



                                <Row className='m-0 pt-2 ' style={{ height: "54px" }}>
                                    <Col span={24} className="m-0 p-0 ">
                                        {

                                            <div className=" d-flex justify-content-center align-items-center m-0 p-0">
                                                <Form.Item>
                                                    <Button
                                                        className="Add-Edit-btton text-white m-0 p-0"
                                                        htmlType="submit"
                                                        type='primary'
                                                        onClick={() => {
                                                            {
                                                                firstselect1 && getTextTemplateSelect == false ? <>
                                                                    {
                                                                        setlastdata(true)
                                                                    }
                                                                </>
                                                                    :
                                                                    <>

                                                                        {
                                                                            setlastdata(false)
                                                                        }
                                                                    </>
                                                            }



                                                        }}
                                                        onSubmitFail
                                                        style={{ backgroundColor: "#720c20" }} >

                                                        {lastdata == true || getTextTemplateSelect == true ? "Save" : "Create"}

                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        }

                                    </Col>
                                </Row>

                            </ModalBody>

                        </Col>
                    </Row>
                </Form>

            </Modal>
        </div >
    )
}
